export function getTableSearch(filters) {
    const searchParams = new URLSearchParams(filters)
    const entries = [...searchParams.entries()]
    entries.forEach(([key, value]) => {
        if (value === 'null' || value === '') {
            searchParams.delete(key);
        }
    });

    return searchParams.toString()
}